import { Link } from "react-router-dom";

const Footer = () => (
    <div className="bg-black p-2 text-center">
        <Link to="/?page=1">
            <h1 className="text-lg">® Movieflix All rights reserved</h1>
        </Link>
    </div>
);

export default Footer;
